import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { GetOwnUserProfile, GetOwnUserProfileError, GetOwnUserProfileSuccess, GetUserProfile, GetUserProfileError, GetUserProfileSuccess, UserHasAccessToLearner, UserHasAccessToLearnerError, UserHasAccessToLearnerSuccess } from "./user-profile.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { of } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class UserProfileEffects {
  constructor(
    private action$: Actions,
    private userProfileService: UserProfileService
  ) {}

  public getMyUserProfile$ = createEffect(() => {
    return this.action$.pipe(
      ofType(GetOwnUserProfile),
      switchMap(() =>
        this.userProfileService.getOwnUserProfile$().pipe(
          map((userProfileResponse: Userprofile) => {
            return GetOwnUserProfileSuccess( { userProfile: userProfileResponse } )
          }),
          catchError((errorResponse: any) => {
            return of(GetOwnUserProfileError({error: errorResponse}));
          })
        )
      )
    );
  });

  public getUserProfileEffect$ = createEffect(() => {
    return this.action$.pipe(
      ofType(GetUserProfile),
      switchMap((payload: {id: number}) => 
        this.userProfileService.getUserProfile$(payload.id).pipe(
          map((result: Userprofile) => {
            return GetUserProfileSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetUserProfileError({error: error}));
          })
        )
      )
    )
  });  

  public getUserHasAccessToLearnerEffect$ = createEffect(() => 
    this.action$.pipe(
      ofType(UserHasAccessToLearner),
      switchMap((payload) => 
        this.userProfileService.isUserHasAccessToLearner$(payload.learnerId).pipe(
          map((result: boolean) => {
            return UserHasAccessToLearnerSuccess({result: result});
          }),
          catchError((error: any) => {
            return of(UserHasAccessToLearnerError({error: error}))
          })
        )
      )
    )
  );
}